// @ts-nocheck



import React, { Component } from 'react';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import qs from 'query-string';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';







import {
  getListInitialState,
  setQueryParams,
  convertVehicleToString,
  formatDateTimeToString } from
'./../../../lib/helpers';
import { passApi } from './../../../lib/api';



import { setFilter } from '../../../ducks/persistFilters';

import { Section } from './../../../components/layout';
import { Popconfirm, Table, Icon, ButtonsRow } from './../../../components/ui';
import { notificationLoading } from './../../../components/Notifications';
import Header from './../../../components/layout/Header';
import { withUserAccess } from './../../withUserAccess';

import { ACT_COLUMNS, canHandleService } from '../lib';

import PassFilter from './Filter';













export const COLUMNS = [
{
  title: 'Марка',
  sorter: true,
  dataIndex: 'vehicle',
  render: (vehicle) => convertVehicleToString(vehicle)
},
{
  title: 'Наименование',
  dataIndex: 'name'
},
{
  title: 'Номер',
  dataIndex: 'number'
},
{
  title: 'Дата выдачи',
  dataIndex: 'maintenanceDate',
  width: '150px',
  render: (value) => formatDateTimeToString(value, 'DD.MM.YYYY')
},
{
  title: 'Период действия',
  width: '150',
  render: (record) => {
    return `${formatDateTimeToString(
      record.startDate,
      'DD.MM.YYYY'
    )} - ${formatDateTimeToString(record.endDate, 'DD.MM.YYYY')}`;
  }
},
{
  title: 'Стоимость',
  dataIndex: 'paymentAmount'
}];


export class List extends Component {
  static defaultProps = {
    location: {}
  };

  state = {
    ...getListInitialState(),
    filterPath: window.location.pathname
  };

  columns = [...COLUMNS, ...ACT_COLUMNS];

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    if (this.canAdd()) {
      this.columns.push({
        stopPropagation: true,
        width: 20,
        dataIndex: 'id',
        render: (id) =>
        <Popconfirm
          title="Вы уверены, что хотите удалить запись?"
          onConfirm={async () => this.deletePass(id)}>

            <Icon type="x" />
          </Popconfirm>

      });
    }
    await this.fetchPassList(page);
  }

  deletePass = async (id) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await passApi.deletePass(id);
      await this.fetchPassList(this.state.page);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  fetchPassList = async (page = 1, params = {}) => {
    const { filterPath } = this.state;
    const filter = this.props.persistFilters[filterPath] || {};
    this.setState({ loading: true });
    const { data, totalCount } = await passApi.fetchPasses({
      ...filter,
      page,
      ...params
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  handleRowClick = (id) => navigate(`/services/pass/${id}`);

  canAdd = () => canHandleService(this.props.userAccess);

  setPersistFilter = async (values) => {
    const { filterPath } = this.state;
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  applyFilter = async (filter) => {
    await this.setPersistFilter(filter);
    await this.fetchPassList();
  };

  cleanFilter = async () => {
    await this.setPersistFilter({});
    await this.fetchPassList();
  };

  handlePrint = async () => {
    try {
      const filter = this.props.persistFilters[this.state.filterPath];
      notificationLoading({
        message: 'Загрузка файла отчета...',
        key: 'print'
      });
      await passApi.printReport(filter);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('print');
    }
  };

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filterPath } =
    this.state;
    const filter = this.props.persistFilters[filterPath];
    return (
      <>
        <Header
          left={<h1>Пропуска</h1>}
          right={
          <ButtonsRow>
              <Button onClick={this.handlePrint}>Печать</Button>
              {this.canAdd() &&
            <Link to="/services/pass/new">
                  <Button type="primary" data-cy="add">
                    Создать
                  </Button>
                </Link>
            }
            </ButtonsRow>
          } />

        <Section>
          <PassFilter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            fetch={this.fetchPassList}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            loading={loading}
            columns={this.columns}
            data={data.map((item) => ({
              ...item,
              key: item.id
            }))} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    persistFilters: state.persistFilters
  }),
  {
    setFilter
  }
)(withUserAccess(List));
